import { route } from "quasar/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function ({ store } /* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach((to, from, next) => {
  	console.log('to path',to.path);
    let safePaths = [
      "/",
      "/login",
      "/logout",
      "/forgot",
      "/activateAccount",
      "/registergate",
      "/register",
      "/registerOutsourcee",
      "/registerBusinessSupport",
      "/forgotPassword",
      "/thank-you-for-the-reference",
    ];
    if (safePaths.includes(to.path)) {
    	console.log('Safe route');
      /*if(store.state.intervals.notification){
				store.commit('clearNotificationInterval');
			}*/
      next();
    } else if (to.path.includes('freelancerProfile')){
    	next();
    } else if (to.path.includes('reference')){
    	next();
    } else if (to.path.includes('approveTestimonial')) {
    	next();
    } else {
    	console.log('Unsafe route');
      //- Disabled for new notification implementation
      // if(!store.state.intervals.notification){
      // 	store.commit('setNotificationInterval');
      // };
      if (store.state.authToken) {
        if (to.meta.admin === true) {
          if (store.state.user.meta.isAdmin === true) {
            next();
          } else {
            next("/");
          }
        } else if (to.meta.outsourceeManager === true) {
          if (
            store.state.user.meta.isAdmin === true ||
            store.state.user.permissions.outsourceeManager === true
          ) {
            next();
          } else {
            next("/");
          }
        } else if (to.meta.billingManager === true) {
          if (
            store.state.user.meta.isAdmin === true ||
            store.state.user.permissions.billingManager === true
          ) {
            next();
          } else {
            next("/");
          }
        } else {
          next();
        }
      } else {
        // store.commit('clearNotificationInterval');
        next("/");
      }
    }
  });

  return Router;
});
